import { render, staticRenderFns } from "./numPronunciation.vue?vue&type=template&id=5e7d26fa&scoped=true&"
import script from "./numPronunciation.ts?vue&type=script&lang=js&"
export * from "./numPronunciation.ts?vue&type=script&lang=js&"
import style0 from "./numPronunciation.less?vue&type=style&index=0&id=5e7d26fa&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e7d26fa",
  null
  
)

export default component.exports